module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=VE - Venezuela.ac7ebc90.svg";